import { SummaryPage } from '../../components'

export default SummaryPage
